import React from 'react';

import { Portal } from '@bringg-frontend/bringg-web-infra';

import DeploymentHistory from './deployment-history';

const DeploymentHistoryPortal = () => {
	return <Portal element={<DeploymentHistory />} nodeId="deployment-history-page" />;
};

export default DeploymentHistoryPortal;
